import { css } from '@emotion/css';
import c from 'classnames';

export const buttonStyles = css`
  &:active {
    color: var(--text-paragraph);
    .MuiButton-startIcon svg {
      fill: var(--link-internal-hover);
    }
  }
`;

export const BUTTON_CONFIG = {
  long: 'w-full p-12',
  short: 'self-start ps-12 pe-16 h-40',
};

export const TYPOGRAPHY_CONFIG = {
  long: 'body-short-01',
  short: 'body-short-02',
};

export const ICON_CONFIG = {
  long: 'me-8',
  short: 'me-4',
};
